const STORAGE_KEY = "menuTourSeen";

export const hasSeenMenuTour = () => {
    if (typeof window === "undefined") return true;
    try {
        return window.localStorage.getItem(STORAGE_KEY) === "1";
    } catch {
        return true;
    }
};

export const markMenuTourSeen = () => {
    if (typeof window === "undefined") return;
    try {
        window.localStorage.setItem(STORAGE_KEY, "1");
    } catch {
        // ignore quota / private mode
    }
};
